import React from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import { PadContainer } from 'smartsuite-ui';
import DashboardViewTitle from './DashboardViewTitle';
import DraggableWidgetItem from './DraggableWidgetItem';
import { getDashboardViewKey } from './customDashboardUtils';

export default function DashboardGroupedWidgets(props) {
    const dashboardViewKey = getDashboardViewKey(
        props.groupWidgets[0].dashboardKey,
        props.groupWidgets[0].viewKey
    );

    const errorMessage =
        props.incorrectlyConfiguredDashboards[dashboardViewKey];

    return (
        <div className="editor-drawer__grouping">
            <DashboardViewTitle
                dashboardTitle={props.groupWidgets[0].dashboardTitle}
                viewKey={props.groupWidgets[0].viewKey}
                viewTitle={props.groupWidgets[0].viewTitle}
            />
            <PadContainer cssClassModifiers={['pad-small']} />
            <PadContainer
                cssClassModifiers={['pad-medium', 'no-pad-top-bottom']}
            >
                {errorMessage && (
                    <div className="editor-drawer__grouping-error">
                        {errorMessage}
                    </div>
                )}
                {orderBy(props.groupWidgets, [
                    'stateData.title',
                    'panelTitle',
                    'tabTitle',
                ]).map((widget) => (
                    <DraggableWidgetItem
                        key={widget.key} // eslint-disable-line react/no-array-index-key
                        gridLayout={props.gridLayout}
                        incorrectlyConfiguredDashboards={
                            props.incorrectlyConfiguredDashboards
                        }
                        onAdd={props.onAdd}
                        setDraggingWidget={props.setDraggingWidget}
                        widget={widget}
                    />
                ))}
            </PadContainer>
        </div>
    );
}

DashboardGroupedWidgets.propTypes = {
    groupWidgets: PropTypes.instanceOf(Object).isRequired,
    incorrectlyConfiguredDashboards: PropTypes.instanceOf(Object).isRequired,
    gridLayout: PropTypes.instanceOf(Array).isRequired,
    onAdd: PropTypes.func.isRequired,
    setDraggingWidget: PropTypes.func.isRequired,
};
